import React from "react";
import DocumentTable from "~/components/document-table/DocumentTable";
import "./attachments.scss";

const AttachmentTable = ({
  formatDate,
  processAttachments,
  loadingAttachments,
  rows,
  onPageChange,
  first,
  showTypeColumn = true,
  handleAttachmentDelete,
  isPayslipFolder = false,
  relatedType = "",
  relatedId = "",
  isFilterApplied,
  totalRecords,
  onSortOrderChange,
  onRefetch,
  nameSubtext,
  publishHandler,
  entityId,
  service,
  unpublishHandler,
  /** When true, show backend file name (e.g. for Payroll process). Overrides isPayslipFolder for display. */
  useOriginalFileName: useOriginalFileNameProp,
  /** When true, show backend storage name (attachmentData.name) for Payroll service line. */
  useBackendFileName = false,
}) => (
  <div className="attachments__body">
    <DocumentTable
      value={processAttachments ?? []}
      loading={loadingAttachments}
      formatDate={formatDate}
      onDelete={handleAttachmentDelete}
      relatedId={relatedId}
      relatedType={relatedType}
      totalRecords={totalRecords}
      rows={rows}
      first={first}
      onPageChange={onPageChange}
      onSortOrderChange={onSortOrderChange}
      isFilterApplied={isFilterApplied}
      isPayslipFolder={isPayslipFolder}
      useOriginalFileName={useOriginalFileNameProp ?? isPayslipFolder}
      useBackendFileName={useBackendFileName}
      emptyMessage="No files found"
      onRefetch={onRefetch}
      nameSubtext={nameSubtext}
      publishHandler={publishHandler}
      entityId={entityId}
      service={service}
      unpublishHandler={unpublishHandler}
    />
  </div>
);

export default AttachmentTable;
